import React from 'react';
import { Phone } from 'lucide-react';

const PhoneButton = () => {
  return (
    <a
      href="tel:+916377733291"
      className="group bg-[#2F3C7E] hover:bg-[#1E2A5A] text-white w-16 h-16 rounded-full shadow-xl hover:shadow-2xl transition-all duration-300 flex items-center justify-center hover:scale-110 hover:-translate-y-1 active:scale-95 z-[99] border-4 border-white/50 hover:border-white/80"
      aria-label="Call us"
    >
      <Phone size={24} className="group-hover:scale-110 transition-transform duration-200" />
    </a>
    
  );
};

export default PhoneButton;

